<template>
  <svg
    :width="size"
    :height="size"
    viewBox="0 0 37 31"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M10.9993 4.88281V3.66667C10.9993 1.65 12.6493 0 14.666 0H21.9993C24.016 0 25.666 1.65 25.666 3.66667V4.88281H34.2167C35.5667 4.88281 36.6667 5.98281 36.6667 7.33281V25.6661C36.6667 28.3661 34.4833 30.5495 31.7833 30.5495H4.88333C2.18333 30.5495 0 28.3661 0 25.6661V7.33281C0 5.98281 1.1 4.88281 2.45 4.88281H10.9993ZM23.216 4.88281V3.66667C23.216 3 22.666 2.45 21.9993 2.45H14.666C13.9993 2.45 13.4493 3 13.4493 3.66667V4.88281H23.216ZM34.2167 7.33281V12.2168C34.2167 14.2335 32.5667 15.8835 30.55 15.8835H6.11667C4.1 15.8835 2.45 14.2335 2.45 12.2168V7.33281H34.2167ZM6.11667 18.3335C4.74364 18.3335 3.47318 17.8788 2.45 17.1109V25.6661C2.45 26.3495 2.71667 26.9495 3.16667 27.3995C3.61667 27.8495 4.21667 28.1161 4.9 28.1161H31.7667C32.45 28.1161 33.05 27.8495 33.5 27.3995C33.95 26.9495 34.2167 26.3495 34.2167 25.6661V17.1114C33.1956 17.8782 31.9266 18.3335 30.55 18.3335H24.4501V20.7826C24.4501 22.1326 23.3501 23.2326 22.0001 23.2326H14.6668C13.3168 23.2326 12.2168 22.1326 12.2168 20.7826V18.3335H6.11667ZM14.6668 18.3335V20.7826H22.0001V18.3335H14.6668Z"
      :fill="color"
    />
  </svg>
</template>
<script>
export default {
  props: {
    color: {
      type: String,
      default: "#3E3B39",
    },
    size: {
      type: Number,
      default: 24,
    },
  },
};
</script>
